// extracted by mini-css-extract-plugin
module.exports = {"fixedBlockSocial":"ShareArticle_fixedBlockSocial__yXx9t","fixedBlockSocialIcons":"ShareArticle_fixedBlockSocialIcons__VxZyO"};